import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SearchResultComponent } from '@softapps/core/pages';

@Component({
  selector: 'soft-field-ok-landeskennzeichen-search-result-view',
  imports: [],
  templateUrl: './search-result-view.component.html',
  styleUrl: './search-result-view.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush })
export class LandeskennzeichenFieldOkSearchResultViewComponent
  implements SearchResultComponent<any>
{
  readonly result = input.required<any>();
}
